import { observable } from "mobx";

export default class CoachHighSchoolModalStore {
    @observable isVisible = false;
    @observable coach = {};
}